import { render, staticRenderFns } from "./staticWidget.vue?vue&type=template&id=105033f9&"
import script from "./staticWidget.vue?vue&type=script&lang=js&"
export * from "./staticWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports